import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

interface AuditLogHostCellProps {
  host?: string | null;
  forwardedHost?: string | null;
  origin?: string | null;
}

// XBIT-4767: where the request came through. Every value is caller-controlled, so it is rendered as plain
// React text only: no link, no dangerouslySetInnerHTML.
const AuditLogHostCell = ({ host, forwardedHost, origin }: AuditLogHostCellProps) => {
  const translate = useTranslate();
  if (host == null && forwardedHost == null && origin == null) {
    return <Typography variant="caption">—</Typography>;
  }
  return (
    <Box>
      <Typography variant="body2">{host}</Typography>
      {origin != null && (
        <Typography variant="caption" color="text.secondary" display="block">
          {`${translate('module.auditLogs.origin')}: ${origin}`}
        </Typography>
      )}
      {forwardedHost != null && forwardedHost !== host && (
        <Typography variant="caption" color="text.secondary" display="block">
          {`${translate('module.auditLogs.forwardedHost')}: ${forwardedHost}`}
        </Typography>
      )}
    </Box>
  );
};

export default AuditLogHostCell;
